import React from 'react';
export function PrivacyPolicy() {
  return <div className="bg-white min-h-screen py-16" data-id="element-953">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-954">
        <h1 className="text-4xl font-extrabold text-warm-900 mb-2" data-id="element-955">
          Privacy Policy
        </h1>
        <p className="text-warm-500 mb-12" data-id="element-956">Last updated: March 6, 2026</p>

        <div className="prose prose-lg max-w-none text-warm-700 space-y-8" data-id="element-957">
          <section data-id="element-958">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-959">
              1. Information We Collect
            </h2>
            <p data-id="element-960">
              When you use Gozie Transportation's services or visit our website,
              we may collect the following types of information:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-961">
              <li data-id="element-962">
                <strong data-id="element-963">Personal Information:</strong> Name, phone number, email
                address, home address, and pickup/drop-off locations provided
                when booking a ride.
              </li>
              <li data-id="element-964">
                <strong data-id="element-965">Medical Information:</strong> Type of mobility
                assistance needed, wheelchair or mobility device details, and
                any special requirements you share with us.
              </li>
              <li data-id="element-966">
                <strong data-id="element-967">Payment Information:</strong> Credit card details,
                insurance information, or Medicaid/Medicare details for billing
                purposes.
              </li>
              <li data-id="element-968">
                <strong data-id="element-969">Usage Data:</strong> Information about how you interact
                with our website, including pages visited and booking activity.
              </li>
            </ul>
          </section>

          <section data-id="element-970">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-971">
              2. How We Use Your Information
            </h2>
            <p data-id="element-972">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-973">
              <li data-id="element-974">Schedule and provide transportation services</li>
              <li data-id="element-975">Communicate with you about your bookings and account</li>
              <li data-id="element-976">Process payments and insurance claims</li>
              <li data-id="element-977">Improve our services and customer experience</li>
              <li data-id="element-978">Comply with legal and regulatory requirements</li>
              <li data-id="element-979">
                Send service-related notifications such as ride confirmations
                and reminders
              </li>
            </ul>
          </section>

          <section data-id="element-980">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-981">
              3. HIPAA Compliance
            </h2>
            <p data-id="element-982">
              As a Non-Emergency Medical Transportation (NEMT) provider, Gozie
              Transportation is committed to protecting your health information
              in accordance with the Health Insurance Portability and
              Accountability Act (HIPAA). We implement appropriate physical,
              technical, and administrative safeguards to protect any protected
              health information (PHI) we receive.
            </p>
          </section>

          <section data-id="element-983">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-984">
              4. Information Sharing
            </h2>
            <p data-id="element-985">
              We do not sell your personal information. We may share your
              information with:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-986">
              <li data-id="element-987">
                <strong data-id="element-988">Our Drivers:</strong> Necessary trip details to provide
                your transportation service.
              </li>
              <li data-id="element-989">
                <strong data-id="element-990">Healthcare Facilities:</strong> When coordinating rides
                on behalf of a medical provider or facility.
              </li>
              <li data-id="element-991">
                <strong data-id="element-992">Insurance Providers:</strong> For billing and claims
                processing when applicable.
              </li>
              <li data-id="element-993">
                <strong data-id="element-994">Legal Authorities:</strong> When required by law or to
                protect the safety of our passengers and staff.
              </li>
            </ul>
          </section>

          <section data-id="element-995">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-996">
              5. Data Security
            </h2>
            <p data-id="element-997">
              We implement industry-standard security measures to protect your
              personal information, including encrypted data transmission,
              secure servers, and restricted access to personal data. However,
              no method of electronic transmission or storage is 100% secure,
              and we cannot guarantee absolute security.
            </p>
          </section>

          <section data-id="element-998">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-999">
              6. Your Rights
            </h2>
            <p data-id="element-1000">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-1001">
              <li data-id="element-1002">
                Request access to the personal information we hold about you
              </li>
              <li data-id="element-1003">Request correction of inaccurate information</li>
              <li data-id="element-1004">
                Request deletion of your personal information, subject to legal
                obligations
              </li>
              <li data-id="element-1005">Opt out of non-essential communications</li>
            </ul>
          </section>

          <section data-id="element-1006">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-1007">
              7. Cookies
            </h2>
            <p data-id="element-1008">
              Our website may use cookies and similar technologies to improve
              your browsing experience. You can control cookie settings through
              your browser preferences.
            </p>
          </section>

          <section data-id="element-1009">
            <h2 className="text-2xl font-bold text-warm-900 mb-4" data-id="element-1010">
              8. Contact Us
            </h2>
            <p data-id="element-1011">
              If you have questions about this Privacy Policy or wish to
              exercise your rights regarding your personal data, please contact
              us:
            </p>
            <div className="mt-4 bg-warm-50 p-6 rounded-xl border border-warm-200" data-id="element-1012">
              <p className="font-bold text-warm-900" data-id="element-1013">
                Gozie Shipping and Transportation
              </p>
              <p data-id="element-1014">4215 58th Ave #5</p>
              <p data-id="element-1015">Bladensburg, MD 20710</p>
              <p className="mt-2" data-id="element-1016">
                Phone:{' '}
                <a href="tel:2404132157" className="hover:underline" data-id="element-1017">
                  (240) 413-2157
                </a>
              </p>
              <p data-id="element-1018">
                Email:{' '}
                <a href="mailto:Podogwu100@gmail.com" className="hover:underline" data-id="element-1019">
                  Podogwu100@gmail.com
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>;
}